"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.parse-int.js");
var _utils = require("../utils");
var _scroll = require("../utils/scroll");
var _touch = require("../mixins/touch");
var _getContainer = require("../mixins/get-container");
var _icon = _interopRequireDefault(require("../icon"));
var _use = (0, _utils.use)('float-btn'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  name: 'float-btn',
  mixins: [_touch.TouchMixin, _getContainer.GetContainerMixin],
  props: {
    px2rem: Boolean,
    width: {
      type: Number,
      default: 70
    },
    height: {
      type: Number,
      default: 70
    },
    margin: {
      type: Number,
      default: 8
    },
    offsetBottom: {
      type: Number,
      default: 108
    },
    duration: {
      type: Number,
      default: 0
    },
    closable: {
      type: Boolean,
      default: false
    },
    dragable: {
      type: Boolean,
      default: true
    },
    business: {
      type: Boolean,
      default: false
    },
    hidingWhenScroll: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      top: 0,
      left: 0,
      isClose: false,
      hasInit: false,
      realWidth: 0,
      realHeight: 0
    };
  },
  computed: {
    isHiding: function isHiding() {
      if (_utils.isServer) return false;
      if (!this.hasInit) return false;
      var hidingLeft = this.left === 10 - this.realWidth;
      var hidingRight = this.left === window.innerWidth - 10;
      console.log('isHiding', hidingLeft, hidingRight);
      return hidingLeft || hidingRight;
    },
    isLeftSide: function isLeftSide() {
      if (_utils.isServer) return false;
      if (!this.hasInit) return false;
      return window.innerWidth / 2 > this.left + this.realWidth;
    }
  },
  watch: {
    moved: function moved(val) {
      if (!this.hidingWhenScroll) return;
      if (val) {
        this.resetTimer();
        this.eventTarget = (0, _scroll.getScrollEventTarget)(this.$el.parentNode);
        this.eventTarget.addEventListener('scroll', this.onScroll);
      } else {
        clearTimeout(this.timer);
        this.eventTarget.removeEventListener('scroll', this.onScroll);
      }
    }
  },
  mounted: function mounted() {
    this.initPos();
  },
  methods: {
    initPos: function initPos() {
      var _this = this;
      this.$refs.floatBtn && (this.$refs.floatBtn.style.transition = 'none');
      var _getComputedStyle = getComputedStyle(this.$refs.floatBtn),
        width = _getComputedStyle.width,
        height = _getComputedStyle.height;
      this.realWidth = parseInt(width, 10);
      this.realHeight = parseInt(height, 10);
      this.left = window.innerWidth - this.realWidth - this.margin;
      this.top = window.innerHeight - this.realHeight - this.offsetBottom;
      setTimeout(function () {
        _this.$refs.floatBtn && (_this.$refs.floatBtn.style.transition = 'all 0.3s ease');
        _this.hasInit = true;
      }, 32);
      console.log(this.left, this.top);
    },
    resetTimer: function resetTimer() {
      var _this2 = this;
      if (this.duration > 0) {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          return _this2.hide();
        }, this.duration);
      }
    },
    hide: function hide() {
      this.left = this.isLeftSide ? 10 - this.realWidth : window.innerWidth - 10;
    },
    show: function show() {
      if (this.isLeftSide) {
        this.left = this.margin;
      } else {
        this.left = window.innerWidth - this.realWidth - this.margin;
      }
      if (this.top < 10) {
        this.top = 10;
      } else if (this.top + this.realHeight > window.innerHeight) {
        this.top = window.innerHeight - this.realHeight - 10;
      }
      this.resetTimer();
    },
    onClose: function onClose() {
      this.isClose = true;
      this.$emit('close');
    },
    onClick: function onClick() {
      this.isHiding ? this.show() : this.$emit('click');
    },
    onScroll: function onScroll() {
      var _this3 = this;
      // console.log('onScroll', 'this.isHiding', this.isHiding)

      if (!this.isHiding) {
        this.hide();
      }
      clearTimeout(this.showTimer);
      this.showTimer = setTimeout(function () {
        return _this3.show();
      }, 300);
    },
    onTouchStart: function onTouchStart(event) {
      if (!this.dragable) return;
      this.touchStart(event);
      this.$refs.floatBtn && (this.$refs.floatBtn.style.transition = 'none');
      var _event$touches$ = event.touches[0],
        clientX = _event$touches$.clientX,
        clientY = _event$touches$.clientY;
      this.startOffsetX = clientX - this.left;
      this.startOffsetY = clientY - this.top;
      clearTimeout(this.timer);
    },
    onTouchMove: function onTouchMove(event) {
      if (!this.dragable) return;
      event.preventDefault();
      this.touchMove(event);
      var _event$touches$2 = event.touches[0],
        clientX = _event$touches$2.clientX,
        clientY = _event$touches$2.clientY;
      if (clientX > 0 && clientX < window.innerWidth) {
        this.left = clientX - this.startOffsetX;
      }
      if (clientY > 0 && clientY < window.innerHeight) {
        this.top = clientY - this.startOffsetY;
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.dragable) return;
      this.$refs.floatBtn && (this.$refs.floatBtn.style.transition = 'all 0.3s ease');
      !this.isHiding && this.show(); // 避免与click事件同时触发
    }
  },
  render: function render(h) {
    var left = this.left,
      top = this.top,
      width = this.width,
      height = this.height,
      closable = this.closable,
      isClose = this.isClose,
      business = this.business,
      px2rem = this.px2rem;
    var styles = {
      width: px2rem ? (0, _utils.px2rem)(width) + "rem" : width + "px",
      height: px2rem ? (0, _utils.px2rem)(height) + "rem" : height + "px",
      left: left + 'px',
      top: top + 'px'
    };
    // console.log('float-btn render', styles)

    return isClose ? null : h("div", {
      "class": bem(),
      "style": styles,
      "ref": "floatBtn"
    }, [h("div", {
      "class": bem('slot', {
        'business': business
      }),
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd,
        "click": this.onClick
      }
    }, [this.slots()]), closable && h(_icon.default, {
      "on": {
        "click": this.onClose
      },
      "class": bem('close'),
      "attrs": {
        "name": "clear"
      }
    })]);
  }
});
exports.default = _default;